import React, { useState } from 'react';
import ContactUsItem from './ContactUsItem';
import { HeadsetMicOutlinedIcon, EmailOutlinedIcon } from 'icons/materialIcons';
import { Box, Grid, Typography } from '@mui/material';
import SendEmailModal from './SendEmailModal'; // Import the modal

const ContactUs = () => {
  const [isEmailModalOpen, setEmailModalOpen] = useState(false);

  // Track active contact options for responsive design
  const isChatActive = false; // Set to true when chat is uncommented
  const isEmailActive = true; // Always true for now
  const activeOptionsCount = (isChatActive ? 1 : 0) + (isEmailActive ? 1 : 0);

  // Dynamic grid sizing based on active options
  const getGridSize = () => {
    if (activeOptionsCount === 1) {
      return { xs: 12, sm: 8, md: 6 }; // Increased width to prevent text wrapping and overlap
    } else {
      return { xs: 12, sm: 6 }; // Half width when multiple options
    }
  };

  const handleContactClick = (method) => {
    if (method === 'Email') {
      setEmailModalOpen(true); // Open the modal
    }
    // Chat functionality commented out for future implementation
    // else {
    //   alert(`${method} button clicked!`);
    // }
  };

  const handleEmailModalClose = () => {
    setEmailModalOpen(false); // Close the modal
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 500, fontSize: '1.4rem', marginBottom: "12px" }} gutterBottom>
        Contact Us
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 1, color: '#828282', fontSize: '0.9rem' }}>
        Our team of experts is available to provide support through chat or email.
      </Typography>
      <Grid container spacing={2} justifyContent="flex-start">
        {/* Chat option - COMMENTED OUT FOR FUTURE IMPLEMENTATION */}
        {/* When uncommenting, change isChatActive to true above and justifyContent back to conditional */}
        {/* <Grid item {...getGridSize()}>
          <ContactUsItem 
            title="Chat with an agent" 
            description="Average response time: 15 minutes" 
            onButtonClick={() => handleContactClick('Chat')}
            buttonText="Start Chat"
          >
            <HeadsetMicOutlinedIcon />
          </ContactUsItem>
        </Grid> */}
        {isEmailActive && (
          <Grid item {...getGridSize()}>
            <ContactUsItem
              title="Email our team"
              description="Average response time: 3 hours"
              onButtonClick={() => handleContactClick('Email')}
              buttonText="Send Email"
            >
              <EmailOutlinedIcon /> {/* Pass the icon as a child */}
            </ContactUsItem>
          </Grid>
        )}
      </Grid>

      {/* Render the SendEmailModal */}
      <SendEmailModal open={isEmailModalOpen} onClose={handleEmailModalClose} />
    </Box>
  );
};

export default ContactUs;
